export * from './buy-card.component';
export * from './step-first/step-first.component';
export * from './result/result.component';
